<template>
    <v-container style="margin-top:60px;" dark>
        <v-card dark>
            <v-row dark justify="center">
                <v-card
                        flat
                        tile
                        class="white--text text-center"
                >
                    <v-card-text style="padding-top: 8px;">
                        Hicards-rutan visar upp dina tittares Hicards när de flexas eller används.

                    </v-card-text>
                </v-card>
            </v-row>
            <v-row justify="center">
                <v-col class="col-8 col-md-5 col-lg-3">
                    <v-text-field
                            type="password"
                            :value="url"
                            outlined
                            label="Browser-länk"
                            dense
                            readonly

                            hide-details
                    >

                        <v-btn small v-clipboard:copy="url"  slot="append" icon >
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                    </v-text-field>
                    <v-card
                            flat
                            tile
                            class="white--text text-center"
                    >
                        <v-card-text style="padding-top: 8px;">
                            Använd denna länk som <i>Browser Source</i> i ditt OBS.

                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="col-6 col-md-6 col-lg-3">
                    <v-select
                            :items="cooldowns"
                            label="Flex-Cooldown"
                            outlined
                            dense
                            hide-details
                            v-on:change="updateFlexReq"
                            v-model="flex_cd"
                            :value="flex_cd"


                    >

                        <template v-slot:item='{item}'> <div>{{item.name}}</div></template>
                        <template v-slot:selection='{item}'><div>{{item.name}}</div></template>
                    </v-select>
                    <v-card
                            flat
                            dark
                            tile
                            class="white--text text-center"
                    >
                        <v-card-text style="padding-top: 8px;">
                            Anger hur ofta Hicards får flexas

                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="col-6 col-md-6 col-lg-3">
                    <v-select
                            :items="tiers"
                            label="Flex-Krav"
                            outlined
                            dense
                            hide-details
                            v-model="flex_req"
                            v-on:change="updateFlexReq"

                    >
                        <template v-slot:item='{item}'> <v-chip small label  :color=item.color text-color="white" > {{item.name}} <small v-if="item.probability!==0" class="ml-2">{{item.probability}}% </small> </v-chip></template>
                        <template v-slot:selection='{item}'> <v-chip small label  :color=item.color text-color="white" > {{item.name}} <small v-if="item.probability!==0" class="ml-2">{{item.probability}}% </small> </v-chip></template>

                    </v-select>
                    <v-card
                            flat

                            tile
                            class="white--text text-center"
                    >
                        <v-card-text style="padding-top: 8px;">
                            Anger minsta kortkvalitet för flex

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="col-12">
                    <v-card
                            flat
                            dark
                            tile
                            class="white--text text-center"
                    >

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="flexTest">
                                Skicka testkort
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>

                    </v-card>


                </v-col>
                <v-col class="col-0 col-md-0 col-lg-3 d-none d-lg-block"></v-col>
            </v-row>
        </v-card>
        <v-responsive :aspect-ratio="16/9">
            <iframe :src=url> </iframe>
        </v-responsive>




    </v-container>
</template>

<script>

    export default {
        name: "HicardsOverlay",
        components:{

        },
        data(){
            return{
                flex_cd:0,
                flex_req:0,
                cooldowns:[
                    {value:0,index:0,name:"Ingen"},
                    {value:5,index:1,name:"5 min"},
                    {value:30,index:2,name:"30 min"},
                    {value:60,index:3,name:"60 min"},
                    {value:120,index:4,name:"120 min"}
                ],
                min_to_index:{
                    0:0,
                    5:1,
                    30:2,
                    60:3,
                    120:4
                },
                tiers:[
                    {value:0,name:"Vanlig",color:"green",probability:47,index:0},
                    {value:1,name:"Rare",color:"blue",probability:37,index:1},
                    {value:2,name:"Epic",color:"purple",probability:15,index:2},
                    {value:3,name:"Legendary",color:"orange",probability:1,index:3},
                    {value:4,name:"Tillåt ej",color:"black",probability:0,index:4}

                ],
                ID:null
            }
        },
        computed:{
            url:function(){
                return window.location.origin+"/widget_hc?id="+this.$store.state.STREAMER.SID;
            }
        },
        methods:{
            updateFlexReq:function(){


                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/hicards_settings?';

                let params ='flexCooldown='+this.flex_cd+'&minDecor='+this.flex_req;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');


                http.send(params);

            },
            flexTest:function(){
                let http = new XMLHttpRequest();
                let url = '/api/use_test_card?';
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 200) {
                        let resp = JSON.parse(http.response);

                        if(resp["status"]==="ok"){
                            self.$store.commit("update_snackbar","Flex-test skickat");


                        }
                        else if(resp["status"]==="notfound"){
                            self.$store.commit("update_snackbar","Ett fel inträffade");

                        }
                    }

                }
                http.send();
            },


        },
        mounted:function(){
            document.title="Hihat - Overlays";

            this.flex_cd=this.$store.state.HICARDS.FLEX_COOLDOWN;
            this.flex_req=this.$store.state.HICARDS.FLEX_REQUIREMENT;
        }
    }
</script>

<style scoped>
    iframe { width:100%;height:100%; }

</style>
